<div class="ui-g loyalty-cluster">
  <div class="ui-g-12">

    <app-kontable title = "{{ 'layout.layout' | translate }}"
                  [columns] = "[
                    'id',
                    'description',
                    { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: selectFilter, filterTemplate: customerStateFilter, filterOptions: {values: listStates}}
                  ]"
                  [titles] = "['common.id', 'common.description']"
                  [paginationType]="serverPagination"
                  [showInfoButton]="false"
                  [showRecoverButton]="true"
                  [showGlobalFilter]="false"
                  [showDetailsButton]="false"
                  [showAddButton]="true"
                  [service]="layoutService"
                  [(fireNewDataAvailable)]="newDataAvailable"
                  (onRecover)="recover($event)"
                  (onAdd)="addNew($event)"
                  (onEdit)="edit($event)"
                  (onRemove)="remove($event)">

                  <ng-template #stateTemplate data-testid="stateTemplate" let-row class="deleted-row">
                    <span *ngIf="row.flg_state && row.flg_state == '1'" class="fa fa-trash-o" title="{{'common.deleted' | translate}}"></span>
                    <span *ngIf="row.flg_state && row.flg_state == '2'" class="fa fa-ban" title="{{'common.suspended' | translate}}"></span>
                  </ng-template>

                  <ng-template #customerStateFilter data-testid="customerStateFilter" let-col>
                    <p-dropdown [options]="listStates" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
                  </ng-template>

    </app-kontable>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-layout/loyalty-layout.component.html